import React, { FC } from 'react';

import { connect } from 'react-redux';

import { DropdownItem } from '@atlaskit/dropdown-menu-12';
import { StatsigFeatureKeys } from '@atlassian/bitbucket-features';
import { Extension } from '@atlassian/forge-ui';

import {
  extensionTitle,
  ForgeRepoCodeOverviewActionExtensionPointAppsList,
} from 'src/components/forge-ui/src';
import { Repository, User } from 'src/components/types';
import { useStatsigGate } from 'src/contexts/feature-provider';
import { getCurrentRepository } from 'src/selectors/repository-selectors';
import { getCurrentUser } from 'src/selectors/user-selectors';
import { BucketState } from 'src/types/state';

export type ForgeRepoCodeOverviewActionAppsListProps = {
  currentUser?: User | null;
  onAppClick: (app: Extension) => void;
  repository?: Repository;
};

/* eslint @typescript-eslint/ban-types: "warn" */
const ForgeRepoCodeOverviewActionAppsList: FC<
  ForgeRepoCodeOverviewActionAppsListProps
> = ({ currentUser, onAppClick, repository }) => {
  const forgeExtNameEnvKey = useStatsigGate(
    StatsigFeatureKeys.forgeExtNameEnvKey
  );

  if (!repository || !repository.workspace) return null;

  return (
    <ForgeRepoCodeOverviewActionExtensionPointAppsList
      AppsListComponent={({ app }) => (
        <DropdownItem
          onClick={() => {
            onAppClick(app);
          }}
        >
          {forgeExtNameEnvKey ? extensionTitle(app) : app.properties.title}
        </DropdownItem>
      )}
      currentUser={currentUser || undefined}
      workspace={repository.workspace}
    />
  );
};

const mapStateToProps = (state: BucketState) => ({
  repository: getCurrentRepository(state),
  currentUser: getCurrentUser(state),
});

// Default export is needed because this is lazy loaded by LazyForgeRepoCodeOverviewActionAppsList
// eslint-disable-next-line import/no-default-export
export default connect(mapStateToProps)(ForgeRepoCodeOverviewActionAppsList);
